const createEditorCode = `
  window.createScriptEditor = function() {
    var id = 'script-editor';
    var element = document.getElementById(id);
    var exists = (null != element);
    if (!exists) {
      element = document.createElement('div'); element.id = 'script-editor';
      element.style.position = 'absolute';
      element.style.width = '30%';
      element.style.height = '100%';
      element.style.left = '0';
      element.style.top = '80px';
      element.style.textAlign = 'left';
      element.style.zIndex = 1000;

      var toolbar = document.createElement('div'); toolbar.id = 'script-editor-toolbar';
      toolbar.style.backgroundColor = 'white';
      toolbar.style.width = '100%';
      toolbar.style.height = '40px';
      toolbar.style.left = '0';
      toolbar.style.top  = '0';
      toolbar.style.textAlign = 'left';

      var applyButton = document.createElement('button'); applyButton.id = 'script-editor-apply';
      applyButton.style.width = '50%'; applyButton.style.height = '100%'; applyButton.style.border = '1px solid';
      applyButton.appendChild(document.createTextNode('Apply'));
      applyButton.onclick = () => {
        var scripts = StatPage.model.getReportScripts();
        StatPage.model.setReportScripts(Object.assign(scripts, { aggregate: [ window.editor.getValue() ] }));
      }
      toolbar.appendChild(applyButton);

      var resetButton = document.createElement('button'); resetButton.id = 'script-editor-reset';
      resetButton.style.width = '50%'; resetButton.style.height = '100%'; resetButton.style.border = '1px solid';
      resetButton.appendChild(document.createTextNode('Reset'));
      resetButton.onclick = () => {
        StatPage.model.clearReportScripts()
        var scripts = StatPage.model.getReportScripts() || {};
        var aggregate = scripts.aggregate || [];
        window.editor.setValue(aggregate.join('\\n\\n'))
      }
      toolbar.appendChild(resetButton);
      element.appendChild(toolbar);

      document.getElementById('page').appendChild(element);
    }
    if ( window.monaco ) {
      var scripts = StatPage.model.getReportScripts() || {};
      var aggregate = scripts.aggregate || [];
      window.editor = monaco.editor.create(element, {
        value: aggregate.join('\\n\\n'),
        language: 'javascript',
        wordWrap: 'wordWrapColumn',
        wordWrapColumn: 40,
        wordWrapMinified: true,   // Set this to false to not auto word wrap minified files
        wrappingIndent: "indent"  // try "same", "indent" or "none"
      });
    } else {
      setTimeout(window.createScriptEditor, 100);
    }
  };
  setTimeout(window.createScriptEditor, 100);
`
const CDN = 'https://unpkg.com/monaco-editor@0.29.1/min'
const initCode = `var require = { paths: { 'vs': '${CDN}/vs' } };
  window.MonacoEnvironment = {
    getWorkerUrl: function(workerId, label) {
      return "data:text/javascript;charset=utf-8,${encodeURIComponent(`
        self.MonacoEnvironment = {
          baseUrl: '${CDN}'
        };
        importScripts('${CDN}/vs/base/worker/workerMain.js');`)}";
    }
  };`
const addScript = ({ src, code }) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    if (src) {
      script.onload = resolve
      script.src = src
      document.querySelector('body').appendChild(script)
    } else if (code) {
      try {
        script.appendChild(document.createTextNode(code))
        document.querySelector('body').appendChild(script)
      } catch {
        script.text = code
        document.querySelector('body').appendChild(script)
      }
      resolve()
    } else reject()
  })

const promiseSerial = funcs =>
  funcs.reduce(
    (promise, func) => promise.then(result => func().then(Array.prototype.concat.bind(result))),
    Promise.resolve([])
  )

const initialize = callback => {
  const scripts = ['vs/loader.js', 'vs/editor/editor.main.nls.js', 'vs/editor/editor.main.js']
  if ('undefined' !== typeof window && 'undefined' !== typeof window.monaco) {
    return callback()
  }
  return addScript({ code: initCode })
    .then(() => promiseSerial(scripts.map(name => () => addScript({ src: `${CDN}/${name}` }))))
    .then(addScript({ code: createEditorCode }))
    .then(callback)
}

export default {
  initialize
}
